// @ts-nocheck
// import React, { useState } from "react";
// import { Menu, IconButton, Button, Box } from "@mui/material";
// import { styled } from "@mui/material/styles";
// import { MobileTimePicker, TimePicker } from "@mui/x-date-pickers";
// import dayjs from "dayjs";
// import PropTypes from "prop-types";
// import { getCssVariableHandler } from "../../../../../utils/styles/getCssVariables";
// import {
//   TableCellWithError
// } from "./SessionPositionEditableSheetTableCell";

// const StyledMenu = styled(Menu)(({ theme }) => ({
//   "& .MuiPaper-root": {
//     border: "1px solid",
//     borderColor: getCssVariableHandler({ variableName: "--primary-pink-hex" }),
//     backgroundColor: "#2A2A2A",
//     color: theme.palette.common.white,
//     borderRadius: "0.25rem",
//     padding: "0 !important",
//     maxHeight: "40vh",
//     overflow: "auto",
//   },
//   "& .MuiMenu-list": {
//     padding: "0 !important",
//     maxHeight: "inherit",
//     overflowY: "auto",
//     borderRadius: "0.25rem",
//   },
// }));

// export const SheetTimeDropdown = ({
//   value,
//   onChange,
//   render,
//   onContextMenu,
//   customError,
// }) => {
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [tempTime, setTempTime] = useState(value || dayjs()); // Temporary time state

//   const handleClick = (event) => {
//     setAnchorEl(event.currentTarget);
//     setTempTime(value); // Reset tempTime when opening
//   };

//   const handleClose = () => {
//     setAnchorEl(null);
//   };

//   const handleTBD = () => {
//     onChange("TBD");
//     setAnchorEl(null);
//   };

//   const handleTimeSelect = (newTime) => {
//     if (!newTime) return;

//     setTempTime(newTime);
//   };

//   const handleApply = () => {
//     onChange(tempTime);
//     handleClose();
//   };

//   return (
//     <TableCellWithError customError={customError} onContextMenu={onContextMenu}>
//       <Box sx={{ cursor: "pointer", width: "100%" }} onClick={handleClick}>
//         {render}
//       </Box>
//       {anchorEl && (
//         <StyledMenu
//           anchorEl={anchorEl}
//           open
//           onClose={handleClose}
//           anchorOrigin={{
//             vertical: "bottom",
//             horizontal: "center",
//           }}
//           transformOrigin={{
//             vertical: "top",
//             horizontal: "center",
//           }}
//         >
//           <Box sx={{ padding: "0.5rem" }}>
//             <MobileTimePicker
//               value={tempTime !== "TBD" ? tempTime : null}
//               onChange={handleTimeSelect}
//               ampm
//               minutesStep={30}
//               sx={{
//                 width: "10rem",
//                 "@media (max-width: 600px)": {
//                   width: "100%",
//                 },
//                 border: "1px solid white",
//                 borderRadius: "8px",
//                 "& .css-19oukd7-MuiButtonBase-root-MuiMenuItem-root-MuiMultiSectionDigitalClockSection-item":
//                   {
//                     color: "black !important",
//                   },
//                 "& input": {
//                   color: "white",
//                   padding: "12px",
//                 },
//                 "& button": {
//                   color: "white",
//                 },
//                 "& ul": {
//                   backgroundColor: "black",
//                 },
//               }}
//             />

//             <Box
//               sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}
//             >
//               <Button
//                 variant="text"
//                 onClick={handleTBD}
//                 sx={{
//                   color: "white",
//                   textTransform: "capitalize",
//                   "&:hover": {
//                     color: getCssVariableHandler({
//                       variableName: "--primary-pink-hex",
//                     }),
//                   },
//                 }}
//               >
//                 TBD
//               </Button>
//               <Button
//                 variant="contained"
//                 size="small"
//                 onClick={handleApply} // Apply changes on OK
//                 sx={{
//                   backgroundColor: "white",
//                   color: "black",
//                   width: "1.5rem",
//                   height: "2.25rem",
//                 }}
//               >
//                 OK
//               </Button>
//             </Box>
//           </Box>
//         </StyledMenu>
//       )}
//     </TableCellWithError>
//   );
// };

// SheetTimeDropdown.propTypes = {
//   value: PropTypes.any,
//   onChange: PropTypes.func.isRequired,
//   render: PropTypes.any,
//   onContextMenu: PropTypes.func,
//   customError: PropTypes.string,
// };

// ----------------------------------------------------------------------------------------------------------------------
// ----------------------------------------------------------------------------------------------------------------------

import { useState } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Menu, Button, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import dayjs from "dayjs";
import PropTypes from "prop-types";
import { getCssVariableHandler } from "../../../../../utils/styles/getCssVariables";
import { TableCellWithError } from "./SessionPositionEditableSheetTableCell";
import {
  getTSeparatedDate,
  normalizeToDateTimeString,
} from "../../../../../utils/methods/dateAndTimeMethods";
import { MobileTimePickerWithIcon } from "../../../../../components/Custom/TimeInput";

const StyledMenu = styled(Menu)(({ theme }) => ({
  "& .MuiPaper-root": {
    border: "1px solid",
    borderColor: getCssVariableHandler({ variableName: "--primary-pink-hex" }),
    backgroundColor: "#2A2A2A",
    color: theme.palette.common.white,
    borderRadius: "0.25rem",
    padding: "0 !important",
    maxHeight: "40vh",
    overflow: "auto",
  },
  "& .MuiMenu-list": {
    padding: "0 !important",
    maxHeight: "inherit",
    overflowY: "auto",
    borderRadius: "0.25rem",
  },
}));

export const SheetTimeDropdown = ({
  value,
  date,
  onChange,
  render,
  onContextMenu,
  customError,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [tempTime, setTempTime] = useState(value || dayjs()); // Temporary time state

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setTempTime(value); // Reset tempTime when opening
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleTBD = () => {
    onChange("TBD");
    setAnchorEl(null);
  };

  const handleTimeSelect = (newTime) => {
    if (!newTime) return;
    const dt = new Date(date);
    dt?.setHours(newTime?.$H);
    dt?.setMinutes(newTime?.$m);
    setTempTime(getTSeparatedDate(dt));
  };

  const handleApply = () => {
    const tempTimeCopy = normalizeToDateTimeString(tempTime);
    onChange(tempTimeCopy);
    handleClose();
  };

  const getTimeInAndTimeOutDates = (startDate, time) => {
    const dt = dayjs(startDate).toDate();
    let hour;
    let min;

    const splittedTime = time?.split?.("T")?.[1];
    hour = splittedTime?.split?.(":")?.[0];
    min = splittedTime?.split?.(":")?.[1];

    dt.setHours(hour);
    dt.setMinutes(min);

    return dt;
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <TableCellWithError
        customError={customError}
        onContextMenu={onContextMenu}
      >
        <Box sx={{ cursor: "pointer", width: "100%" }} onClick={handleClick}>
          {render}
        </Box>
        {anchorEl && (
          <StyledMenu
            anchorEl={anchorEl}
            open
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            onMouseOver={(e) => {
              e?.stopPropagation();
            }}
          >
            <Box
              sx={{ padding: "0.5rem" }}
              onKeyDown={(e) => {
                e.stopPropagation();
              }}
            >
              <MobileTimePickerWithIcon
                value={
                  tempTime !== "TBD"
                    ? // tempTime
                      dayjs(
                        getTimeInAndTimeOutDates(
                          date,
                          dayjs(tempTime)?.format("YYYY-MM-DDTHH:mm:ss"),
                        ),
                      )
                    : null
                }
                onChange={handleTimeSelect}
                ampm
                minutesStep={30}
                sx={{
                  width: "10rem",
                  "@media (max-width: 600px)": {
                    width: "100%",
                  },
                  border: "1px solid white",
                  borderRadius: "8px",
                  "& .css-19oukd7-MuiButtonBase-root-MuiMenuItem-root-MuiMultiSectionDigitalClockSection-item":
                    {
                      color: "black !important",
                    },
                  "& input": {
                    color: "white",
                    padding: "12px",
                  },
                  "& button": {
                    color: "white",
                  },
                  "& ul": {
                    backgroundColor: "black",
                  },
                }}
              />

              <Box
                sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}
              >
                <Button
                  variant="text"
                  onClick={handleTBD}
                  sx={{
                    color: "white",
                    textTransform: "capitalize",
                    "&:hover": {
                      color: getCssVariableHandler({
                        variableName: "--primary-pink-hex",
                      }),
                    },
                  }}
                >
                  TBD
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  onClick={handleApply} // Apply changes on OK
                  sx={{
                    backgroundColor: "white",
                    color: "black",
                    width: "1.5rem",
                    height: "2.25rem",
                  }}
                >
                  OK
                </Button>
              </Box>
            </Box>
          </StyledMenu>
        )}
      </TableCellWithError>
    </LocalizationProvider>
  );
};

SheetTimeDropdown.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  render: PropTypes.any,
  onContextMenu: PropTypes.func,
  customError: PropTypes.string,
};